import { Newspaper, Unlink } from "@wix/wix-ui-icons-common";
import React from "react";
import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from "./../ricos-content/index.js";
import { LINK_MODAL_ID } from "./../_shared/link-modal/constants.js";
import { toggleLinkModal } from "./../_shared/link-modal/toggle-link-modal.js";
import { createSettingsButton } from "./../_shared/plugin-toolbar/create-settings-button.js";
import { createSeparator } from "./../_shared/plugin-toolbar/separator/create-separator.js";
import { createUrlLinkButton } from "./../_shared/plugin-toolbar/url-link-button/create-url-link-button.js";
import { getAnchorData } from "./../_shared/resolvers/get-anchor-data.js";
import { getUrlLinkData } from "./../_shared/resolvers/get-url-link-data.js";
import { isAlwaysVisible } from "./../_shared/resolvers/is-always-visible.js";
import { isAnchorInText } from "./../_shared/resolvers/is-anchor-in-text.js";
import { isLinkInText } from "./../_shared/resolvers/is-link-in-text.js";
import { isLinkPreviewEnabled } from "./../_shared/resolvers/is-link-preview-enabled.js";
import {
  LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON,
  LINK_PLUGIN_REMOVE_BUTTON,
  LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON
} from "./data-hooks.js";
import { AnchorLinkButton } from "./toolbar/anchor-link-button.js";
import { DisplayLinkPreview } from "./toolbar/display-link-preview-button.js";
import { RemoveLinkButton } from "./toolbar/remove-link-button.js";
const getToolbarButtons = (_config, services) => {
  return [
    {
      id: "anchorLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_SCROLL_TO_ANCHOR_BUTTON,
      attributes: {
        visible: isAnchorInText,
        selectedAnchorLinkData: getAnchorData
      },
      tooltip: null,
      icon: () => /* @__PURE__ */ React.createElement("span", { style: { textDecoration: "underline" } }, services.t("LinkTo_Toolbar_GoTo")),
      command: ({ tiptapEditor, attributes: { selectedAnchorLinkData } }) => {
        tiptapEditor.commands.scrollToAnchor(selectedAnchorLinkData);
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AnchorLinkButton, { toolbarItem })
    },
    createUrlLinkButton({
      services,
      attributes: {
        visible: isLinkInText,
        selectedUrlLinkData: getUrlLinkData
      }
    }),
    createSeparator({
      visible: isAlwaysVisible
    }),
    {
      id: "displayLinkPreview",
      type: "toggle",
      dataHook: LINK_PLUGIN_DISPLAY_AS_LINK_PREVIEW_BUTTON,
      tooltip: "LinkPanelContainer_DisplayAsLinkPreview",
      icon: Newspaper,
      attributes: {
        visible: isLinkPreviewEnabled
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.commands.createLinkPreview();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(DisplayLinkPreview, { toolbarItem })
    },
    createSettingsButton({
      modalId: LINK_MODAL_ID,
      command: ({ publicCommands, referenceElement, modals }) => {
        toggleLinkModal({
          initialValue: publicCommands.getLinkDataInSelection(),
          modalService: modals,
          onSave: (link) => {
            publicCommands.insertDecoration(
              link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE,
              link
            );
          },
          onUnlink: (link) => {
            publicCommands.deleteDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
          },
          referenceElement,
          returnFocusToEditor: true,
          onClickOutside: {
            on: "pointerup",
            handler: (e) => {
              if (!referenceElement?.contains?.(e.target)) {
                modals.closeModal(LINK_MODAL_ID);
                return;
              }
            }
          }
        });
      }
    }),
    createSeparator({
      visible: isAlwaysVisible
    }),
    {
      id: "removeLink",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: Unlink,
      attributes: {
        visible: isLinkInText
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetLink().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    },
    {
      id: "removeAnchor",
      type: "toggle",
      dataHook: LINK_PLUGIN_REMOVE_BUTTON,
      tooltip: "LinkPanelContainer_RemoveButton",
      icon: Unlink,
      attributes: {
        visible: isAnchorInText
      },
      command: ({ tiptapEditor }) => {
        tiptapEditor.chain().focus().unsetAnchor().run();
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(RemoveLinkButton, { toolbarItem })
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=get-toolbar-buttons.js.map
